
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[locationSlug]/[serviceSlug]",
      function () {
        return require("private-next-pages/services/[locationSlug]/[serviceSlug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[locationSlug]/[serviceSlug]"])
      });
    }
  